const isEnterOrSpacePressed = (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    return true;
  }
  return false;
};

export default isEnterOrSpacePressed;
